<template lang="pug">
.box.keyStat(:class="{ highlight }")
  label {{ title }}
  loading-icon(tag="strong", v-if="value === null || typeof value === 'undefined'")
  strong(v-else) {{ value }}
</template>

<script>
export default {
    props: {
        title: {
            type: String,
        },
        value: {
            type: [String, Number],
            required: false,
        },
        highlight: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.keyStat {
    label {
        font-size: 0.8em;
        user-select: none;
        text-transform: uppercase;
    }
    strong {
        font-weight: 300;
        color: #55585a;
        font-size: 1.5em;
    }

    &.highlight {
        background-color: #8c9199;

        label {
            color: #fff;
        }

        strong {
            color: #fff;
            font-weight: bold;
        }
    }
}
</style>
